import PhotoUpload from "./PhotoUpload";
import ClosenessPicker from "./ClosenessPicker";
import ContactList from "./ContactList";

/**
 * The left rail: portrait, how close you are, and how to reach them. Sticks to
 * the top of the viewport while the dossier scrolls beside it.
 */
export default function ProfileRail({
  name,
  photoUrl,
  relationshipType,
  closeness,
  birthday,
  contact,
  onUploadPhoto,
  onRemovePhoto,
  onChangeCloseness,
}) {
  return (
    <aside className="profile-rail">
      <PhotoUpload
        photoUrl={photoUrl}
        name={name}
        relationshipType={relationshipType}
        onUpload={onUploadPhoto}
        onRemove={onRemovePhoto}
      />
      <ClosenessPicker value={closeness} onChange={onChangeCloseness} />
      <ContactList {...contact} birthday={birthday} />
    </aside>
  );
}
